
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Minibushireforcorporate() {



const cardData =
{
  keyword: 'Mini Bus Hire for Corporate in Pune',
  heading: 'eTravo: Mini Bus Hire for Corporate in Pune',
  headingDescription: 'eTravo provides reliable and cost-effective mini bus rental services tailored specifically for corporate travel in Pune. Whether it’s daily staff transport, event shuttles, business trips, or team outings, our fleet of well-maintained AC mini buses is designed to meet every organizational need. With professional drivers, flexible scheduling, and on-time service, our mini buses ensure comfort, safety, and efficiency for your employees and executive teams. From 17 to 32-seater options, eTravo offers scalable transport solutions that fit both short-term and long-term corporate requirements across Pune.',

  top: 'Top Corporate-Friendly Locations in Pune for Mini Bus Travel',
  topPlaces: [
    {
      title: 'JW Marriott Hotel Pune',
      description: 'A premium venue for business summits, seminars, and corporate awards. Located on Senapati Bapat Road, this hotel is frequently served by eTravo mini buses transporting teams attending corporate galas, product launches, and executive conferences.'
    },
    {
      title: 'Shivaji Nagar Assembly Hall',
      description: 'Known for hosting business seminars, government-industry forums, and startup events. Our mini buses regularly shuttle staff and participants from various parts of Pune to this centrally located meeting space.'
    },
    {
      title: 'The Corinthians Resort & Club',
      description: 'Located in Undri, this resort is ideal for offsite meetings and team-building activities. eTravo’s mini buses provide comfortable and scenic transport for teams heading out for overnight retreats or corporate celebrations.'
    },
    {
      title: 'Raga Lawns',
      description: 'A popular venue in Koregaon Park Annex for business networking dinners, corporate celebrations, and cultural events. Our mini buses help with efficient multi-trip shuttles for corporate employees and guests.'
    },
    {
      title: 'Deccan College Convention Hall',
      description: 'This historic venue is often used for formal lectures, company training programs, and knowledge-sharing sessions. Our 24–30-seater mini buses ensure bulk staff movement with zero delays.'
    },
    {
      title: 'Balgandharva Rang Mandir',
      description: 'A prime cultural auditorium in Shivajinagar, often rented by corporates for internal celebrations, employee award nights, or industry presentations. eTravo’s mini buses facilitate punctual group transport across the city.'
    },
    {
      title: 'Magarpatta City',
      description: 'An integrated township housing offices, training centers, and convention venues. Our mini buses serve as daily commutes and event transport modes for corporates based here.'
    },
    {
      title: 'Pune International Exhibition Centre (Moshi)',
      description: 'Used for large-scale trade fairs and tech expos, this venue often demands mid-size group travel. eTravo’s mini buses help navigate longer distances with comfort and coordinated logistics.'
    },
    {
      title: 'Aga Khan Palace',
      description: 'Sometimes chosen for heritage-themed offsites and leadership retreats, this national monument in Yerwada is accessible via our guided corporate travel routes.'
    },
    {
      title: 'Balewadi High Street',
      description: 'An emerging corporate zone known for evening networking events, pop-up summits, and HR meetups. Our mini buses handle organized staff movement in and out of this bustling destination.'
    }
  ],

  services: [
    {
      name: 'Corporate Mini Bus Rental Pune',
      description: 'eTravo offers fully customizable mini bus rental services for companies in Pune looking for professional group transport. Our range includes 17, 22, and 30-seater AC mini buses, ideal for daily staff travel, short-term projects, or recurring event needs. The buses are driven by courteous, uniformed drivers and backed by real-time support.'
    },
    {
      name: 'Staff Transport Mini Bus Pune',
      description: 'Designed for smooth daily employee commutes, our staff transport mini buses are scheduled to match your office shifts. We offer multiple route plans, pickup/drop coordination, and monthly contract options to streamline your HR’s transport responsibilities.'
    },
    {
      name: 'Office Commute Mini Bus Hire Pune',
      description: 'Our office commute packages include air-conditioned mini buses with structured pickup points, fixed routes, and SMS/WhatsApp-based arrival alerts. Ideal for large offices located in Hadapsar, Kharadi, or Baner that require safe and punctual transportation for teams.'
    },
    {
      name: 'Business Mini Bus Services Pune',
      description: 'For company-wide meetings, factory visits, and client facility tours, our business-focused mini bus services offer short-term rentals with flexible timing, standby vehicles, and onboard amenities. A dependable option for teams traveling together.'
    },
    {
      name: 'Affordable Corporate Mini Bus Pune',
      description: 'We provide economical mini bus rental solutions with transparent billing, no hidden costs, and value-packed packages. Whether you need the service for one day or the entire month, eTravo ensures affordability without compromising quality or safety.'
    },
    {
      name: 'Mini Bus for Employee Shuttle Pune',
      description: 'Ideal for companies managing shift-based operations, our employee shuttle mini buses are available for regular or rotational use. Includes route planning, GPS tracking, and dedicated support for admins handling multiple batches of employees.'
    },
    {
      name: 'Mini Bus for Corporate Outings Pune',
      description: 'Perfect for team outings, picnics, and sports days, our AC mini buses provide ample space and legroom, making sure your employees arrive refreshed. Storage space for food, equipment, or games is also available for an enhanced travel experience.'
    },
    {
      name: 'AC Mini Bus Rental Pune',
      description: 'Every bus is equipped with powerful air-conditioning, clean interiors, adjustable pushback seating, and anti-skid flooring. These features ensure a smooth, climate-controlled ride through Pune’s busy streets and during long trips.'
    },
    {
      name: 'Mini Bus for Team Transport Pune',
      description: 'From inter-office transfers to field visits, eTravo’s mini buses are the smart choice for team logistics. Each vehicle is checked before every trip, and our drivers are trained to handle time-sensitive corporate travel.'
    },
    {
      name: 'Mini Bus for Corporate Events Pune',
      description: 'Event organizers prefer eTravo’s mini bus service to manage speaker shuttles, guest arrivals, and staff movement during conferences, training camps, and exhibitions held across Pune.'
    },
    {
      name: 'Reliable Mini Bus Hire Pune',
      description: 'Backed by a fleet that’s always ready and a customer support team that’s always listening, eTravo’s reputation in Pune is built on timely arrivals, clean buses, and repeat corporate clients who trust us with their group transport needs.'
    },
    {
      name: 'Daily Mini Bus Services Pune',
      description: 'Sign up for daily contracts where your team has access to fixed daily travel with minimal hassle. Our fleet managers coordinate directly with your admin team to manage routes, attendance, and trip monitoring.'
    },
    {
      name: 'Mini Bus for Business Trips Pune',
      description: 'Need to travel to clients in Mumbai or visit a factory in Satara? Our mini buses are designed for comfortable intercity business trips, with enough space for files, devices, and gear. Reclining seats and storage racks included.'
    },
    {
      name: 'Mini Bus on Rent Pune',
      description: 'Available for both corporate and SME use, our rent-a-mini-bus model suits one-off requirements like training camps, vendor meets, or campus visits. Book with just a few clicks and receive live tracking updates.'
    },
    {
      name: 'Comfortable Corporate Mini Bus Pune',
      description: 'Our buses are equipped with soft suspension, ergonomic seating, and noise-reduced cabins. Designed specifically for long days on the road, these features help reduce travel fatigue and ensure a relaxed arrival at your event or office.'
    }
  ],

  tableData: [
    ['Corporate Mini Bus Rental Pune', 'Staff Transport Mini Bus Pune'],
    ['Office Commute Mini Bus Hire Pune', 'Business Mini Bus Services Pune'],
    ['Affordable Corporate Mini Bus Pune', 'Mini Bus for Employee Shuttle Pune'],
    ['Mini Bus for Corporate Outings Pune', 'AC Mini Bus Rental Pune'],
    ['Mini Bus for Team Transport Pune', 'Mini Bus for Corporate Events Pune'],
    ['Reliable Mini Bus Hire Pune', 'Daily Mini Bus Services Pune'],
    ['Mini Bus for Business Trips Pune', 'Mini Bus on Rent Pune'],
    ['Comfortable Corporate Mini Bus Pune', '']
  ],





"whychoose": [
    {
        "WhyChooseheading": "Efficient Mini Bus Rentals for Corporate Travel",
        "WhyChoosedescription": "eTravo provides well-maintained mini buses (13 to 26 seaters) designed specifically for corporate teams, perfect for events, offsites, airport transfers, and daily commuting in Pune."
    },
    {
        "WhyChooseheading": "Ideal for Small to Mid-Sized Corporate Groups",
        "WhyChoosedescription": "Our mini buses offer the right balance between space and agility, making them perfect for transporting compact teams to business meetings, team outings, or training sessions."
    },
    {
        "WhyChooseheading": "Comfortable, AC-Equipped Buses with Modern Features",
        "WhyChoosedescription": "Every mini bus comes with pushback seats, air conditioning, clean interiors, and ample luggage space—providing a smooth and relaxed travel experience for corporate staff and guests."
    },
    {
        "WhyChooseheading": "Flexible Packages for Daily and Event-Based Use",
        "WhyChoosedescription": "We offer flexible plans—hourly hire, full-day rental, or multi-day usage—for mini bus transport needs during corporate functions, factory visits, or seminars."
    },
    {
        "WhyChooseheading": "Trained Drivers and Route Management Support",
        "WhyChoosedescription": "Our experienced and courteous drivers ensure safe and timely service. For larger bookings, we provide transport coordinators to help plan routes and pickup schedules efficiently."
    },
    {
        "WhyChooseheading": "GPS Tracking and Real-Time Ride Monitoring",
        "WhyChoosedescription": "All mini buses are GPS-enabled and monitored through our central dashboard, allowing your admin teams to track routes, receive ETAs, and ensure timely operations."
    },
    {
        "WhyChooseheading": "Safety, Hygiene, and Compliance at All Times",
        "WhyChoosedescription": "Our mini buses follow strict sanitization routines and are equipped with fire extinguishers, seat belts, and first-aid kits. We ensure compliance with all corporate travel safety norms."
    },
    {
        "WhyChooseheading": "Corporate Billing with Monthly Invoicing and GST",
        "WhyChoosedescription": "We support GST-compliant invoices, monthly billing options, and detailed reporting—ideal for finance teams managing transport expenses across departments or events."
    }
]
}

const faqData = [
    [
        {
            question: 'What seating capacities are available for mini bus hire?',
            answer: 'eTravo offers mini buses ranging from 13 to 26 seats, suitable for small to mid-sized corporate groups attending events, site visits, or offsites in Pune.'
        },
        {
            question: 'Can we hire a mini bus just for a few hours or one-way travel?',
            answer: 'Yes, we offer hourly, one-way, and full-day rental options based on your requirements. Whether it’s a short meeting or airport drop, we’ve got you covered.'
        },
        {
            question: 'Are your mini buses air-conditioned and clean?',
            answer: 'Absolutely. All our mini buses are AC-equipped, regularly sanitized, and maintained to high hygiene standards for a comfortable travel experience.'
        },
        {
            question: 'Is driver service included in the mini bus rental?',
            answer: 'Yes, our professional drivers are part of the package. They are trained in corporate etiquette and familiar with Pune city routes and corporate hubs.'
        },
        {
            question: 'Can we track the bus during the journey?',
            answer: 'Yes, all mini buses are GPS-enabled for real-time tracking. You can monitor location, check ETAs, and ensure timely execution of your corporate schedule.'
        },
        {
            question: 'Is corporate invoicing available for regular usage?',
            answer: 'Yes, we provide GST-compliant monthly invoices and itemized trip details to help corporate clients track transport usage easily.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Nilesh Shinde',
        designation: 'HR Manager, Avantech Industries',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo’s mini buses for our training center visits and airport transfers. The buses are always on time, clean, and ideal for our team size.”'
    },
    {
        name: 'Ms. Sheetal Patankar',
        designation: 'Admin Executive, BharatSoft Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s mini bus service helped us manage our corporate event logistics efficiently. Drivers were cooperative, and the entire process was hassle-free.”'
    }
];















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus Hire for Corporate in Pune",
  "image": "https://www.etravo.in/images/keyword/mini-bus-hire-corporate-pune.jpg",
  "description": "Book mini bus hire for corporate needs in Pune with eTravo. Ideal for staff transport, office commutes, team outings, and business events. Choose AC mini buses with experienced drivers, reliable service, and affordable rates for corporate travel.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/mini-bus-hire-corporate-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Mini Bus Hire for Corporate in Pune | Staff Transport & Business Travel | eTravo</title>
  <meta 
    name="description" 
    content="Hire AC mini buses for corporate outings, employee transport, office commutes, and events in Pune. eTravo provides affordable and reliable mini bus rental services for businesses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Minibushireforcorporate;